__turbopack_context__.v({
  "actualPrice": "ProductPrice-module-scss-module__SE3X9q__actualPrice",
  "basePrice": "ProductPrice-module-scss-module__SE3X9q__basePrice",
  "priceContainer": "ProductPrice-module-scss-module__SE3X9q__priceContainer",
});
